<mat-dialog-content>
  <div class="header">
    <h1 class="api-key-title">Api Key</h1>
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
  <div class="form">
    <span>Name</span>
    <mat-form-field
      class="form-field kh-no-padding kh-dense-input"
      appFormField
    >
      <input
        type="text"
        [id]="'name-' + data.apiKey.id"
        matInput
        [value]="data.apiKey.name"
        (change)="handleNameChange($event, data.apiKey)"
      />
    </mat-form-field>
    <span>Token</span>
    <mat-form-field
      class="form-field kh-no-padding kh-dense-input"
      appFormField
    >
      <input
        type="text"
        matInput
        [value]="data.apiKey.token"
        [disabled]="true"
      />
    </mat-form-field>
    <span>Expires</span>
    <mat-form-field
      class="form-field kh-no-padding kh-dense-input"
      appFormField
    >
      <input
        type="text"
        matInput
        [value]="getExpiresAtFormatted(data.apiKey)"
        [disabled]="true"
      />
    </mat-form-field>
    <span>Provisioning</span>
    <img
      class="apikey-qrcode"
      [src]="bypassSanitizer(data.apiKey.token_qrcode)"
    />
    <div class="form-buttons">
      <a class="close-button" [mat-dialog-close]="false">Cancel</a>
      <div class="actions">
        <a
          *hasPrivilege="'tenant_api_key/update'"
          mat-raised-button
          (click)="handleSaveClick($event, data.apiKey)"
          [disabled]="pending || modifiedAPIKeys[data.apiKey.id] === undefined"
          color="primary"
          >Save</a
        >
        <a
          *hasPrivilege="'tenant_api_key/revoke'"
          mat-raised-button
          color="warn"
          [mat-dialog-close]="data.apiKey"
          >Revoke</a
        >
      </div>
    </div>
  </div>
</mat-dialog-content>
